import React from "react";

const TabHeader = ({items = [], chargeType, setChargeType}) => {
  return (
    <>
      <div className="d-none d-sm-inline-flex tab-header-container">
        <div
          onClick={() => setChargeType(0)}
          className={`first bg-transparent-link ${chargeType === 0 && "active"}`}
        >
          {items[0]}
        </div>
        <div
          onClick={() => setChargeType(1)}
          className={`second bg-transparent-link ${chargeType === 1 && "active"}`}
        >
            {items[1]}
        </div>
        <div
          onClick={() => setChargeType(2)}
          className={`third bg-transparent-link ${chargeType === 2 && "active"}`}
        >
            {items[2]}
        </div>
      </div>
      <div className="d-flex d-sm-none flex-grow-1">
        <select
          value={chargeType}
          className="form-select custom-dropdown font-size-14"
          onChange={(e) => setChargeType(parseInt(e.target.value))}
        >
          <option value={0}>{items[0]}</option>
          <option value={1}>{items[1]}</option>
          <option value={2}>{items[2]}</option>
        </select>
      </div>
    </>
  );
};

export default TabHeader;
